import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useEvolvedContext } from '../../context'
import NationalFooter from '../../components/national-footer'
import { UniversalFooter } from '../../components/universal-footer'
import UnifiedHeader from '../../components/unified-header'
import ErrorFeature from '../../components/error-feature'

const Error = ({ error, status }) => {
  const isEvolved = useEvolvedContext()
  return (
    <Fragment>
      <UnifiedHeader />
      <main>
        <ErrorFeature error={error} status={status} />
      </main>
      {isEvolved ? <UniversalFooter /> : <NationalFooter />}
    </Fragment>
  )
}

Error.defaultProps = {
  status: 404,
}

Error.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  status: PropTypes.number,
}

export default Error
